import { render, staticRenderFns } from "./ToolbarSignatarios.vue?vue&type=template&id=d0c1505e&scoped=true"
import script from "./ToolbarSignatarios.vue?vue&type=script&lang=js"
export * from "./ToolbarSignatarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c1505e",
  null
  
)

export default component.exports